import React, { useState } from "react";
import { Spinner } from "reactstrap";
import Select from "react-select";
import axios from "../api/axios";

const STATUS_OPTIONS = [
  { value: "Open", label: "Open", color: "#3B82F6", bg: "#EFF6FF", icon: "📋" },
  { value: "Scheduled", label: "Scheduled", color: "#059669", bg: "#ECFDF5", icon: "📅" },
  { value: "Inprogress", label: "In Progress", color: "#D97706", bg: "#FFFBEB", icon: "🔧" },
  { value: "Completed", label: "Completed", color: "#16A34A", bg: "#F0FDF4", icon: "✅" },
  { value: "Unresolved", label: "Unresolved", color: "#DC2626", bg: "#FEF2F2", icon: "⚠️" },
];

const S = {
  overlay: {
    position: "fixed", inset: 0, background: "rgba(15,23,42,0.65)",
    backdropFilter: "blur(5px)", zIndex: 1055,
    display: "flex", alignItems: "center", justifyContent: "center",
    padding: "1rem", animation: "fadeIn 0.18s ease",
  },
  card: {
    background: "#fff", borderRadius: "20px", width: "100%", maxWidth: 530,
    boxShadow: "0 30px 70px rgba(15,23,42,0.22), 0 0 0 1px rgba(15,23,42,0.06)",
    overflow: "hidden", fontFamily: "'DM Sans', 'Segoe UI', sans-serif",
    animation: "slideUp 0.22s cubic-bezier(0.34,1.56,0.64,1)",
  },
  header: {
    background: "linear-gradient(140deg, #0F172A 0%, #1E3A5F 55%, #1a4480 100%)",
    padding: "1.5rem 1.75rem 1.3rem", position: "relative", overflow: "hidden",
  },
  glow1: {
    position: "absolute", top: -50, right: -30, width: 180, height: 180,
    borderRadius: "50%",
    background: "radial-gradient(circle, rgba(59,130,246,0.22) 0%, transparent 70%)",
    pointerEvents: "none",
  },
  glow2: {
    position: "absolute", bottom: -40, left: 10, width: 120, height: 120,
    borderRadius: "50%",
    background: "radial-gradient(circle, rgba(16,185,129,0.14) 0%, transparent 70%)",
    pointerEvents: "none",
  },
  headerInner: {
    position: "relative", zIndex: 1,
    display: "flex", alignItems: "flex-start", justifyContent: "space-between",
  },
  iconBadge: {
    width: 46, height: 46, borderRadius: 13,
    background: "rgba(255,255,255,0.11)", border: "1px solid rgba(255,255,255,0.18)",
    display: "flex", alignItems: "center", justifyContent: "center",
    fontSize: 22, marginBottom: "0.8rem",
  },
  title: {
    color: "#fff", fontSize: "1.18rem", fontWeight: 700,
    margin: 0, letterSpacing: "-0.3px",
  },
  subtitle: {
    color: "rgba(255,255,255,0.48)", fontSize: "0.76rem", marginTop: 3,
  },
  closeBtn: {
    background: "rgba(255,255,255,0.08)", border: "1px solid rgba(255,255,255,0.14)",
    color: "rgba(255,255,255,0.65)", borderRadius: 8, width: 30, height: 30,
    display: "flex", alignItems: "center", justifyContent: "center",
    cursor: "pointer", fontSize: 15, lineHeight: 1, flexShrink: 0,
    transition: "all 0.15s",
  },
  body: { padding: "1.4rem 1.75rem 1rem" },
  sectionLabel: {
    display: "block", fontSize: "0.68rem", fontWeight: 700,
    letterSpacing: "0.09em", color: "#94A3B8",
    textTransform: "uppercase", marginBottom: "0.55rem",
  },
  statusGrid: {
    display: "grid", gridTemplateColumns: "repeat(5, 1fr)",
    gap: "0.4rem", marginBottom: "1.3rem",
  },
  statusChip: (sel, color, bg) => ({
    display: "flex", flexDirection: "column", alignItems: "center",
    justifyContent: "center", gap: "0.25rem",
    padding: "0.5rem 0.25rem", borderRadius: 11, cursor: "pointer",
    border: `2px solid ${sel ? color : "#E2E8F0"}`,
    background: sel ? bg : "#FAFAFA",
    transition: "all 0.14s", userSelect: "none",
    fontSize: "0.68rem", fontWeight: sel ? 700 : 500,
    color: sel ? color : "#94A3B8",
    boxShadow: sel ? `0 2px 8px ${color}28` : "none",
  }),
  chipIcon: { fontSize: 16, lineHeight: 1 },
  divider: { height: 1, background: "#F1F5F9", margin: "0 0 1.25rem" },
  grid2: { display: "grid", gridTemplateColumns: "1fr 1fr", gap: "0.75rem" },
  fieldLabel: {
    display: "block", fontSize: "0.72rem", fontWeight: 600,
    color: "#64748B", marginBottom: "0.35rem",
  },
  input: {
    width: "100%", padding: "0.48rem 0.75rem",
    border: "1.5px solid #E2E8F0", borderRadius: 10,
    fontSize: "0.83rem", color: "#0F172A", outline: "none",
    background: "#F8FAFC", transition: "border 0.15s, background 0.15s",
    fontFamily: "inherit", boxSizing: "border-box", cursor: "pointer",
  },
  previewBanner: {
    marginTop: "1.1rem",
    background: "linear-gradient(135deg, #F0F9FF, #F0FDF4)",
    border: "1.5px solid #BAE6FD", borderRadius: 12,
    padding: "0.7rem 1rem",
  },
  previewHeading: {
    fontSize: "0.65rem", fontWeight: 800, letterSpacing: "0.1em",
    color: "#0284C7", textTransform: "uppercase", marginBottom: "0.45rem",
  },
  chipRow: { display: "flex", flexWrap: "wrap", gap: "0.3rem" },
  pill: (color) => ({
    display: "inline-flex", alignItems: "center", gap: 3,
    padding: "0.18rem 0.55rem", borderRadius: 20,
    background: `${color}14`, border: `1px solid ${color}35`,
    color, fontSize: "0.7rem", fontWeight: 700,
  }),
  footer: {
    padding: "0.9rem 1.75rem 1.4rem",
    display: "flex", alignItems: "center", justifyContent: "space-between",
    borderTop: "1.5px solid #F1F5F9", gap: "0.75rem",
  },
  totalBadge: {
    fontSize: "0.72rem", color: "#64748B", fontWeight: 500,
    display: "flex", alignItems: "center", gap: 5,
  },
  cancelBtn: {
    padding: "0.55rem 1.15rem", borderRadius: 10, cursor: "pointer",
    background: "#F1F5F9", border: "none", color: "#475569",
    fontSize: "0.83rem", fontWeight: 600, fontFamily: "inherit",
    transition: "background 0.15s",
  },
  exportBtn: (loading) => ({
    display: "flex", alignItems: "center", gap: "0.45rem",
    padding: "0.55rem 1.4rem", borderRadius: 10,
    cursor: loading ? "not-allowed" : "pointer",
    background: loading
      ? "#94A3B8"
      : "linear-gradient(135deg, #0F172A 0%, #1a3a5c 100%)",
    border: "none", color: "#fff", fontSize: "0.83rem", fontWeight: 700,
    fontFamily: "inherit", transition: "all 0.18s",
    boxShadow: loading ? "none" : "0 4px 14px rgba(15,23,42,0.28)",
    opacity: loading ? 0.75 : 1,
  }),
  errorBox: {
    display: "flex", alignItems: "flex-start", gap: "0.5rem",
    background: "#FEF2F2", border: "1.5px solid #FECACA", borderRadius: 10,
    padding: "0.6rem 0.85rem", marginBottom: "1rem",
    fontSize: "0.78rem", color: "#B91C1C",
  },
};

// ── react-select theme ────────────────────────────────────────────────────────
const selectStyles = {
  control: (b, s) => ({
    ...b, borderRadius: 10, border: "1.5px solid #E2E8F0",
    background: "#F8FAFC", boxShadow: "none", minHeight: 36,
    fontSize: "0.83rem",
    "&:hover": { borderColor: "#94A3B8" },
    ...(s.isFocused ? { borderColor: "#3B82F6", background: "#fff" } : {}),
  }),
  option: (b, s) => ({
    ...b, fontSize: "0.81rem", borderRadius: 6, margin: "1px 4px",
    width: "calc(100% - 8px)",
    background: s.isSelected ? "#0F172A" : s.isFocused ? "#F1F5F9" : "#fff",
    color: s.isSelected ? "#fff" : "#0F172A",
  }),
  menu: (b) => ({
    ...b, borderRadius: 12, overflow: "hidden",
    boxShadow: "0 8px 24px rgba(15,23,42,0.12)", border: "1px solid #E2E8F0",
  }),
  menuList: (b) => ({ ...b, padding: 4 }),
  placeholder: (b) => ({ ...b, color: "#CBD5E1", fontSize: "0.81rem" }),
  singleValue: (b) => ({ ...b, color: "#0F172A", fontSize: "0.81rem" }),
  clearIndicator: (b) => ({ ...b, color: "#94A3B8", cursor: "pointer", padding: "4px" }),
  dropdownIndicator: (b) => ({ ...b, color: "#94A3B8", padding: "4px" }),
  indicatorSeparator: () => ({ display: "none" }),
  valueContainer: (b) => ({ ...b, padding: "2px 10px" }),
};

const getDefaultDates = () => {
  const today = new Date();
  const thirtyDaysAgo = new Date(today);
  thirtyDaysAgo.setDate(today.getDate() - 30);

  return {
    from: thirtyDaysAgo.toISOString().split('T')[0],
    to: today.toISOString().split('T')[0],
  };
};

const ExportTicketsModal = ({ isOpen, toggle, propertyList = [], requestTypes = [] }) => {
  const defaultDates = getDefaultDates();

  const [selectedStatuses, setSelectedStatuses] = useState([]);
  const [fromDate, setFromDate] = useState(defaultDates.from);
  const [toDate, setToDate] = useState(defaultDates.to);
  const [selectedProperty, setSelectedProperty] = useState(null);
  const [selectedType, setSelectedType] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const reset = () => {
    setSelectedStatuses([]); setFromDate(""); setToDate("");
    setSelectedProperty(null); setSelectedType(null); setError("");
  };
  const handleClose = () => { reset(); toggle(); };

  const toggleStatus = (opt) =>
    setSelectedStatuses((prev) =>
      prev.find((s) => s.value === opt.value)
        ? prev.filter((s) => s.value !== opt.value)
        : [...prev, opt]
    );

  const hasFilters =
    selectedStatuses.length > 0 || fromDate || toDate ||
    selectedProperty?.value || selectedType?.value;

  const handleExport = async () => {
    setError("");
    if (fromDate && toDate && new Date(fromDate) > new Date(toDate)) {
      setError("'From' date cannot be after 'To' date.");
      return;
    }
    setLoading(true);
    try {
      const response = await axios.post(
        "v2/maintenance/workflow/export/technical-staff",
        {
          statuses: selectedStatuses.map((s) => s.value),
          startDate: fromDate || undefined,
          endDate: toDate || undefined,
          propertyID: selectedProperty?.value || undefined,
          requestType: selectedType?.value || undefined,
        },
        { responseType: "blob" }
      );
      const disposition = response.headers["content-disposition"] || "";
      const match = disposition.match(/filename="?([^";\n]+)"?/);
      const filename = match ? match[1] : `maintenance_jobs_${new Date().toISOString().slice(0, 10)}.xlsx`;
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", filename);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
      handleClose();
    } catch (err) {
      if (err.response?.data instanceof Blob) {
        try {
          const json = JSON.parse(await err.response.data.text());
          setError(json.message || "Export failed. Please try again.");
        } catch { setError("Export failed. Please try again."); }
      } else {
        setError(err.response?.data?.message || "Export failed. Please try again.");
      }
    } finally {
      setLoading(false);
    }
  };

  if (!isOpen) return null;

  return (
    <>
      <style>{`
        @keyframes fadeIn  { from { opacity: 0 } to { opacity: 1 } }
        @keyframes slideUp { from { opacity: 0; transform: translateY(18px) scale(0.97) }
                             to   { opacity: 1; transform: translateY(0)     scale(1)    } }
      `}</style>

      <div style={S.overlay} onClick={(e) => e.target === e.currentTarget && handleClose()}>
        <div style={S.card}>

          {/* Header */}
          <div style={S.header}>
            <div style={S.glow1} /><div style={S.glow2} />
            <div style={S.headerInner}>
              <div style={{ position: "relative", zIndex: 1 }}>
                <div style={S.iconBadge}>📊</div>
                <h5 style={S.title}>Export Maintenance Jobs</h5>
                <p style={S.subtitle}>Select filters · download your Excel report</p>
              </div>
              <button
                style={S.closeBtn}
                onClick={handleClose}
                onMouseEnter={(e) => (e.currentTarget.style.background = "rgba(255,255,255,0.18)")}
                onMouseLeave={(e) => (e.currentTarget.style.background = "rgba(255,255,255,0.08)")}
              >✕</button>
            </div>
          </div>

          {/* Body */}
          <div style={S.body}>

            {error && (
              <div style={S.errorBox}>
                <span style={{ fontSize: 15, flexShrink: 0 }}>⚠️</span>
                {error}
              </div>
            )}

            {/* Status toggle grid */}
            <span style={S.sectionLabel}>Status</span>
            <div style={S.statusGrid}>
              {STATUS_OPTIONS.map((opt) => {
                const sel = !!selectedStatuses.find((s) => s.value === opt.value);
                return (
                  <div
                    key={opt.value}
                    style={S.statusChip(sel, opt.color, opt.bg)}
                    onClick={() => toggleStatus(opt)}
                    title={opt.label}
                  >
                    <span style={S.chipIcon}>{opt.icon}</span>
                    <span>{opt.label}</span>
                  </div>
                );
              })}
            </div>

            <div style={S.divider} />

            {/* Date range */}
            <span style={S.sectionLabel}>Date Range</span>
            <div style={{ ...S.grid2, marginBottom: "1.15rem" }}>
              {[["From", fromDate, setFromDate, toDate, "max"],
              ["To", toDate, setToDate, fromDate, "min"]].map(
                ([lbl, val, setter, bound, boundKey]) => (
                  <div key={lbl}>
                    <label style={S.fieldLabel}>{lbl}</label>
                    <input
                      type="date"
                      style={S.input}
                      value={val}
                      {...{ [boundKey]: bound || undefined }}
                      onChange={(e) => setter(e.target.value)}
                      onFocus={(e) => {
                        e.target.style.borderColor = "#3B82F6";
                        e.target.style.background = "#fff";
                      }}
                      onBlur={(e) => {
                        e.target.style.borderColor = "#E2E8F0";
                        e.target.style.background = "#F8FAFC";
                      }}
                    />
                  </div>
                )
              )}
            </div>

            {/* Property + Type */}
            <div style={S.grid2}>
              <div>
                <span style={S.sectionLabel}>Property</span>
                <Select
                  options={propertyList.map((p) => ({ value: p._id, label: p.title }))}
                  value={selectedProperty}
                  onChange={setSelectedProperty}
                  styles={selectStyles}
                  placeholder="All properties"
                  isClearable
                />
              </div>
              <div>
                <span style={S.sectionLabel}>Request Type</span>
                <Select
                  options={requestTypes.map((t) => ({ value: t, label: t }))}
                  value={selectedType}
                  onChange={setSelectedType}
                  styles={selectStyles}
                  placeholder="All types"
                  isClearable
                />
              </div>
            </div>

            {/* Active filter preview */}
            {hasFilters && (
              <div style={S.previewBanner}>
                <div style={S.previewHeading}>Active Filters</div>
                <div style={S.chipRow}>
                  {selectedStatuses.map((s) => {
                    const opt = STATUS_OPTIONS.find((o) => o.value === s.value);
                    return (
                      <span key={s.value} style={S.pill(opt?.color || "#64748B")}>
                        {opt?.icon} {s.label}
                      </span>
                    );
                  })}
                  {fromDate && <span style={S.pill("#6366F1")}>📆 {fromDate}</span>}
                  {toDate && <span style={S.pill("#6366F1")}>→ {toDate}</span>}
                  {selectedProperty?.value && <span style={S.pill("#0891B2")}>🏢 {selectedProperty.label}</span>}
                  {selectedType?.value && <span style={S.pill("#7C3AED")}>🔖 {selectedType.label}</span>}
                </div>
              </div>
            )}
          </div>

          {/* Footer */}
          <div style={S.footer}>
            <div style={S.totalBadge}>
              <span style={{ fontSize: 14 }}>📁</span>
              {selectedStatuses.length === 0
                ? "All statuses"
                : `${selectedStatuses.length} status${selectedStatuses.length > 1 ? "es" : ""} selected`}
            </div>
            <div style={{ display: "flex", gap: "0.6rem" }}>
              <button
                style={S.cancelBtn}
                onClick={handleClose}
                disabled={loading}
                onMouseEnter={(e) => (e.target.style.background = "#E2E8F0")}
                onMouseLeave={(e) => (e.target.style.background = "#F1F5F9")}
              >
                Cancel
              </button>
              <button
                style={S.exportBtn(loading)}
                onClick={handleExport}
                disabled={loading}
                onMouseEnter={(e) => { if (!loading) e.currentTarget.style.boxShadow = "0 6px 20px rgba(15,23,42,0.36)"; }}
                onMouseLeave={(e) => { e.currentTarget.style.boxShadow = "0 4px 14px rgba(15,23,42,0.28)"; }}
              >
                {loading ? (
                  <><Spinner size="sm" style={{ width: 13, height: 13, borderWidth: 2 }} /> Generating…</>
                ) : (
                  <><span style={{ fontSize: 14 }}>⬇</span> Download Excel</>
                )}
              </button>
            </div>
          </div>

        </div>
      </div>
    </>
  );
};

export default ExportTicketsModal;